const pageLayout = 'total, sizes, prev, pager, next, jumper'

const pageSizes = [10, 20, 30, 40, 50, 100, 500]

export const paginationConfig = {
  layout: pageLayout,
  pageSizes,
  background: true,
}

const pageLayoutMobile = 'prev, pager, next'

export const _paginationConfigMobile = {
  layout: pageLayoutMobile,
  background: false,
  pagerCount: 5,
}
